import React from "react";
import { ScreenFrame } from "components/onboarding/ScreenFrame";

const screenInfo = {
  title: "Opa, a plataforma do seu inversor está sendo adicionada!",
  body: [
    "Não se preocupe, vamos te notificar assim que a sua plataforma estiver disponível.",
  ],
  nextScreen: "/admin/monitoring",
  dashboardScreen: "/admin/monitoring",
};

const MonitoringSuccessScreen = ({ history, location }) => {
  const handleButtonClick = () => {
    const returnToDashboard = location.state?.returnToDashboard;
    returnToDashboard
      ? history.replace(screenInfo.dashboardScreen)
      : history.push(screenInfo.nextScreen);
  };

  return (
    <ScreenFrame
      body={screenInfo.body}
      buttonText="Continuar"
      title={screenInfo.title}
      variant="success"
      onClick={handleButtonClick}
    />
  );
};

export default MonitoringSuccessScreen;
